import { useState } from 'react';
import DateInput from 'common/components/form/inputs/date';
import NumberInput from 'common/components/form/inputs/NumberInput';
import DangerousActionModal from 'common/components/modals/DangerousActionModal';
import { Row, Col } from 'reactstrap';
import editEmpty from 'assets/svg/actions/edit-empty.svg';
import save from 'assets/svg/actions/save.svg';
import remove from 'assets/svg/actions/remove.svg';
import SvgRender from 'common/components/general/SvgRender';
import { formatDate } from 'common/utils/dates';
import { formattedValue } from './helpers';

const SingleValue = ({
  indexValue,
  value,
  date,
  mode,
  onDateChange,
  onNumberInputChange,
  onAddClick,
  onEditClick,
  onSaveClick,
  onDeleteClick,
  dateError,
  valueError,
  className,
  disabled,
  setDeleting
}) => {
  const [modalOpen, setModal] = useState(false);
  return (
    <Row className={`single-value ${className}`}>
      <Col xs={4}>
        {mode === 'add' ? (
          <DateInput
            error={dateError}
            className={`edit-input`}
            hasTime={false}
            value={date}
            onChange={date => onDateChange(date)}
          />
        ) : (
          <div className="cell-display ps-3 d-flex align-items-center justify-content-start">
            {formatDate(indexValue.value_date, { time: true })}
          </div>
        )}
      </Col>
      <Col xs={6}>
        {mode === 'edit' || mode === 'add' ? (
          <NumberInput
            error={valueError}
            value={value}
            className="edit-input"
            onChange={e => onNumberInputChange(e.target.value)}
            placeholder="Value"
            decimalScale={4}
          />
        ) : (
          <div className="cell-display ps-3 d-flex align-items-center justify-content-start">
            {formattedValue(value)}
          </div>
        )}
      </Col>
      <Col xs={2}>
        {mode === 'add' && value && date && (
          <div onClick={onAddClick} className={`circled-button circled-button-save`}>
            <SvgRender src={save} className="text-white" style={{ width: 12 }} />
          </div>
        )}
        {mode === 'display' && (
          <div onClick={onEditClick} className={`circled-button circled-button-display`}>
            <SvgRender src={editEmpty} className="text-white" style={{ width: 12 }} />
          </div>
        )}
        {mode === 'edit' && (
          <div className="d-flex align-items-center ">
            <div
              onClick={() => {
                setModal(true);
                setDeleting(true);
              }}
              className={`circled-button circled-button-delete me-1 ${disabled ? 'disabled' : ''}`}
            >
              <SvgRender className="text-white" src={remove} style={{ width: 10 }} />
            </div>
            <div
              onClick={onSaveClick}
              className={`circled-button circled-button-save ${disabled ? 'disabled' : ''}`}
            >
              <SvgRender src={save} className="text-white" style={{ width: 12 }} />
            </div>
          </div>
        )}
      </Col>
      <DangerousActionModal
        transparent
        onAccept={onDeleteClick}
        closeModal={() => {
          setModal(false);
          setDeleting(false);
        }}
        isOpen={modalOpen}
        actionText="DELETE"
        header="Delete Index Value"
        body={
          <div className="text-center">
            You are about to delete this value. <br />
            Are you sure you want to continue?
          </div>
        }
      />
    </Row>
  );
};

export default SingleValue;
